import React, { Component } from 'react'
import createComponent from '@ycos/fela/src/createComponent'
import { Grid } from './../../index'

const Container = createComponent('div', ({ breakpoints }) => ({
  background: '#1D8089',
  bottom: 0,
  left: 0,
  marginBottom: 0,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: 0,
  maxWidth: `${breakpoints.xlarge.width}px`,
  opacity: 0.25,
  overflow: 'hidden',
  position: 'absolute',
  right: 0,
  top: 0,
  width: '100%',
  zIndex: 100000
}))

const OverlayColumn = createComponent('div', () => ({
  background: '#472D9B',
  height: '100000vh'
}))

// Key combination for this is `cmd + ;`
const KEY_CODES_COMMAND = [91, 93]
const KEY_CODES_COLON = [186]

const getPersistedState = () => (typeof window !== 'undefined' ? window.localStorage.getItem('CH_GRIDOVERLAY_VISIBLE') : false)
const setPersistedState = (state) => (typeof window !== 'undefined' ? window.localStorage.setItem('CH_GRIDOVERLAY_VISIBLE', state) : false)

class GridOverlay extends Component {
  constructor() {
    super()

    this.state = {
      visible: getPersistedState() === 'true'
    }

    this.onKeyDown = this.onKeyDown.bind(this)
    this.toggleVisibility = this.toggleVisibility.bind(this)
  }

  componentDidMount() {
    typeof window !== 'undefined' && window.addEventListener('keydown', this.onKeyDown, false)
  }

  componentWillUnmount() {
    typeof window !== 'undefined' && window.removeEventListener('keydown', this.onKeyDown, false)
  }

  onKeyDown(e) {
    const { keyCode } = e
    if (KEY_CODES_COMMAND.includes(keyCode)) {
      this.setState({
        commandPressed: true
      })
    } else if (KEY_CODES_COLON.includes(keyCode) && this.state.commandPressed) {
      this.toggleVisibility()
    }
  }

  toggleVisibility() {
    const newVisibility = !this.state.visible
    this.setState({
      visible: newVisibility
    })

    setPersistedState(newVisibility)
  }

  render() {
    return (
      this.state.visible && (
        <Container breakpoints={this.props.breakpoints}>
          <Grid.Row>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
            <Grid.Span small={{ offset: 0, width: 1 }} medium={{ offset: 0, width: 1 }}>
              <OverlayColumn>&nbsp;</OverlayColumn>
            </Grid.Span>
          </Grid.Row>
        </Container>
      )
    )
  }
}

export default GridOverlay
